import { L1Object } from 'core/l1Object/L1Object';
import React from 'react';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import styles from './l1ObjectBudgetManagement.module.scss';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import {
  L1ObjectBudgetManagementColumns,
  useL1ObjectBudgetManagementModel
} from './L1ObjectBudgetManagementModel';
import { Order } from 'core/order/Order';
import i18n from 'i18n';
import { Modal } from 'components/common/Modal/Modal';
import { RtbCampaignListBasic } from 'core/rtbCampaign/RtbCampaign';

export const L1ObjectBudgetManagement: React.FC<{
  order: Order;
  l1Object: Partial<L1Object>;
  initL1Object: Partial<L1Object> | undefined;
  l2ObjectList: RtbCampaignListBasic[];
  budgetDataList?: { id: string; budget: number }[];
  submit: (budgetMap) => void;
  cancel: () => void;
}> = ({
  order,
  l1Object,
  initL1Object,
  l2ObjectList,
  budgetDataList,
  submit,
  cancel
}) => {
  const { loading, viewData, columns, budgets, canSubmit } =
    useL1ObjectBudgetManagementModel(
      order,
      l1Object,
      initL1Object,
      l2ObjectList,
      budgetDataList
    );

  const onSubmit = () => {
    if (!canSubmit) {
      return;
    }
    submit(budgets);
  };

  return (
    <>
      {loading && <LoadingIndicator />}
      <Modal
        fullScreen={true}
        title={i18n.t('l1ObjectBudgetManagement.title', {
          num: l2ObjectList.length
        })}
        primaryButton={{
          title: i18n.t('common.buttons.confirm'),
          disabled: !canSubmit,
          callback: onSubmit
        }}
        secondaryButton={{
          title: i18n.t('common.buttons.cancel'),
          callback: cancel
        }}
        dismiss={cancel}
        animation={false}
      >
        <div className={styles.contentArea}>
          <StickableTanstackTable
            stickFirstColumn
            keyField={L1ObjectBudgetManagementColumns.NAME}
            data={viewData}
            columns={columns}
            hidePagination={true}
            noDataIndication={i18n.t('common.labels.noData')}
            defaultSorted={[
              {
                dataField: L1ObjectBudgetManagementColumns.NAME,
                order: 'asc'
              }
            ]}
          />
        </div>
      </Modal>
    </>
  );
};
